export enum DistanceUnit {
    Meters,
    Kilometers,
    Miles,
    Yards
}
